import React from 'react';

export const TableRow = ({ children, className }) => {
	return <tr className={`hover:bg-glassColor/20 ${className ?? ''}`}>{children}</tr>;
};
